import type { Tone } from '../types';

export const growthTone = (value?: string | null): Tone | undefined => {
    if (value?.startsWith('+') || value?.startsWith('>')) return 'up';
    if (value?.startsWith('-')) return 'down';
    return undefined;
};

// Matches the design system's typography tone variants (success / destructive).
const TONE_CLASS: Record<Tone, string> = {
    up: 'text-green-600 dark:text-green-400',
    down: 'text-destructive',
};

export const toneClass = (tone?: Tone): string =>
    tone ? TONE_CLASS[tone] : 'text-foreground';
